import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { SettingsPage } from '@/features/settings/pages/SettingsPage'

const searchSchema = z.object({
  tab: z.enum(['business', 'branches', 'taxes', 'etims', 'roles', 'loyalty', 'pos', 'hospitality']).catch('business'),
})

export const Route = createFileRoute('/_app/settings/')({
  validateSearch: searchSchema,
  component: SettingsPage,
})
